import { render } from "./IssuesPage.vue?vue&type=template&id=bcee2894&scoped=true"
import script from "./IssuesPage.vue?vue&type=script&lang=js"
export * from "./IssuesPage.vue?vue&type=script&lang=js"

import "./IssuesPage.vue?vue&type=style&index=0&id=bcee2894&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcee2894"]])

export default __exports__